// @flow

import { GLOBAL_APP_COUNT } from 'web-ssr/app/common/constants';

export const buildServiceSharingDescription = (
  serviceName: string,
  isUpcoming: boolean = false
) => {
  if (isUpcoming) {
    return `${serviceName} is not yet available on Zapier; please request it and we’ll notify you when it’s available. However, you can already connect ${serviceName} alternatives to our ${GLOBAL_APP_COUNT} connected apps.`;
  } else {
    return `Instantly connect ${serviceName} with the apps you use everyday. ${serviceName} integrates with ${GLOBAL_APP_COUNT} other apps on Zapier - it's the easiest way to automate your work.`;
  }
};

// FIXME: host should come via next/config `publicRuntimeConfig`
export const buildSharingUrl = (path: string) => `https://zapier.com${path}`;
